import { render } from "./FotoGalleryComponent.vue?vue&type=template&id=b642bbe0&scoped=true"
import script from "./FotoGalleryComponent.vue?vue&type=script&lang=js"
export * from "./FotoGalleryComponent.vue?vue&type=script&lang=js"

import "./FotoGalleryComponent.vue?vue&type=style&index=0&id=b642bbe0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b642bbe0"]])

export default __exports__